import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

interface RoleBasedRouteProps {
  children: React.ReactNode;
  allowedRoles: string[];
}

export function RoleBasedRoute({ children, allowedRoles }: RoleBasedRouteProps) {
  const { user, isAuthenticated } = useAuth();

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  // SuperAdmin bypasses all role checks
  if (user?.isSuperAdmin) {
    return <>{children}</>;
  }

  // Union logic: user needs ANY of the allowed roles
  const hasAllowedRole = user?.roles.some((role) => allowedRoles.includes(role));
  if (user && !hasAllowedRole) {
    return <Navigate to="/" replace />;
  }

  return <>{children}</>;
}
